import React, { useState } from "react";
import { CommonModal, CommonButton, CommonStepIndicator } from "../Input";
import { motion, AnimatePresence } from "framer-motion";
import Step0SelectCustomer from "./Withdrawal/Step0SelectCustomer";
import EnterDenominations from "./TopUp/EnterDenominations";
import TopUpSuccess from "./TopUp/TopUpSuccess";

const TopUpModal = ({ show, onHide, customer: initialCustomer, hideStep0 = false }) => {
  const [currentStep, setCurrentStep] = useState(hideStep0 ? 2 : 1);
  const [selectedCustomer, setSelectedCustomer] = useState(initialCustomer);

  const handleNext = () => {
    if (currentStep < 3) setCurrentStep(currentStep + 1);
  };

  const handleBack = () => {
    if (currentStep > (hideStep0 ? 2 : 1)) setCurrentStep(currentStep - 1);
  };

  const handleSelectCustomer = (customer) => {
    setSelectedCustomer(customer);
    handleNext();
  };

  const handleClose = () => {
    setCurrentStep(hideStep0 ? 2 : 1);
    setSelectedCustomer(initialCustomer);
    onHide();
  };

  const steps = [
    { id: 1, label: "Select Customer" },
    { id: 2, label: "Enter Denominations" },
    { id: 3, label: "Receipt" },
  ];

  const displaySteps = hideStep0 ? steps.filter(s => s.id !== 1) : steps;
  const displayCurrentStep = hideStep0 ? currentStep - 1 : currentStep;



  return (
    <CommonModal
      show={show}
      onHide={handleClose}
      title="Top-up by Cash"
      size="xl"
      fullscreen={true}
      headerClassName="px-4 py-3"
      footer={
        currentStep === 2 ? (
          <div className="d-flex justify-content-end gap-3 w-100 px-3">
            <CommonButton variant="outline" onClick={handleBack}>
              Back
            </CommonButton>
            <CommonButton className="px-5" onClick={handleNext}>
              Confirm Top Up
            </CommonButton>
          </div>
        ) : null
      }
    >
      <div className="px-4 pb-4">
        {currentStep < 3 && <CommonStepIndicator steps={displaySteps} currentStep={displayCurrentStep} />}

        <AnimatePresence mode="wait">
          {currentStep === 1 && (
            <motion.div
              key="step0"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <Step0SelectCustomer onSelectCustomer={handleSelectCustomer} />
            </motion.div>
          )}
          {currentStep === 2 && (
            <motion.div
              key="step1"
              initial={{ opacity: 0, x: 20 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -20 }}
              transition={{ duration: 0.3 }}
            >
              <EnterDenominations customer={selectedCustomer} />
            </motion.div>
          )}
          {currentStep === 3 && (
            <motion.div
              key="step2"
              initial={{ opacity: 0, scale: 0.95 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.4 }}
            >
              <TopUpSuccess onBackHome={handleClose} />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </CommonModal>
  );
};

export default TopUpModal;
